/* export */ function ApiProperty(...args) {
	return function() {};
}
/* export */ function ApiPropertyOptional(...args) {
	return function() {};
}
exports.ApiProperty = ApiProperty;
exports.ApiPropertyOptional = ApiPropertyOptional;
exports.getSchemaPath = function() {};